import { Component, OnInit, ViewChild } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { ActivatedRoute, Router } from '@angular/router';
import { ContactsService } from '../contacts.service';
import { QuillEditorComponent } from 'ngx-quill';
import { FileHolder } from 'angular2-image-upload';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  contactForm: DVFormGroup;
  isAddState = true;
  groups : [];
  @ViewChild('editor', {
    static: true
  })
  editor: QuillEditorComponent;
  constructor(
    private contactApi: ContactsService,
    private notifier: SnotifyService,
    private route: ActivatedRoute,
    private router: Router
  ) {
      
      this.contactApi.getContactById(1).subscribe((Response)=>{
        console.log(Response.data.contact, ' lllllll');
        if (Response.data.contact.length === 0) {
          this.isAddState = true;
        } else {
          this.isAddState = false;
          this.contactForm.patchValue(Response.data.contact);

        }
      });
    this.contactForm = new DVFormGroup({
      address: new DVFormControl(),
      email: new DVFormControl(),
      mapAddress: new DVFormControl(),
      image: new DVFormControl(),
      imageAlt: new DVFormControl(),
      imageTitle: new DVFormControl(),
      metaTitle: new DVFormControl(),
      metaDescription: new DVFormControl(),
      metaKeywords: new DVFormControl(),
    });
  }

  ngOnInit() {}
  SubmitForm() {
    if (this.contactForm.valid) {
      console.log('Content', this.contactForm.value);
      if (this.isAddState == true) {
        this.contactApi.addContact(this.contactForm.value).subscribe(Response => {
          console.log(Response + 'ssssssssssssssssssssss');
          this.notifier.success('Contact Has Added Successfully');
        });
      } else {
        this.contactForm.value.id = 1;
        this.contactApi.editContact(this.contactForm.value, 1).subscribe((Response) => {
          console.log(Response);
          this.notifier.success('Contact Edited Successfully');
        }, err => {
          this.notifier.error(err.error.userMessage);
        });
      }
    } else {
      this.contactForm.forceShowErrors();
    }
  }
  imageUploaded(holder: FileHolder) {
    if (holder.serverResponse.status === 200) {
      const imageBody = holder.serverResponse.response.body;
      delete imageBody.message;
      this.addImage(imageBody);
    }
  }
  private addImage(src) {
    const control = <DVFormControl> this.contactForm.controls[`image`];
    const value: string = control.value || '';
    control.setValue(src.data.filePath);
  }

  imageRemoved(holder: FileHolder) {
  }
  // EditForm() {
  //   if (this.contactForm.valid) {
  //   this.contactForm.value.id = this.route.snapshot.params.id;
  //   this.contactApi.editContact(this.contactForm.value, this.route.snapshot.params.id).subscribe((Response) => {
  //     console.log(Response);
  //     this.notifier.success('Contact Edited Successfully');
  //   }, err => {
  //     this.notifier.error(err.error.userMessage);
  //   });
  //  } else {
  //   this.contactForm.forceShowErrors();
  // }
  // }
}
